<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                        <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
                            :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
                            :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <LazySelect
                            get-url="getUnidadeslazy"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('nav.registration.units')"
                            @input="unidadeSelecionada = $event"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <LazySelect
                            get-url="getGruposlazy"
                            text="nome"
                            value="id_grupo"
                            :label="$t('nav.registration.groups')"
                            @input="grupoSelecionado = $event"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <LazySelect
                            get-url="getTurnospassageiroslazy"
                            text="cod_turno"
                            value="id_turno"
                            :label="$t('nav.registration.shifts')"
                            @input="turnoSelecionado = $event"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="1">
                        <v-select :items="statusOptions" v-model="statusSelecionado" item-text="text"
                            item-value="value" :label="$t('qrcodeSendHistoryReport.status')" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="1">
                        <v-select :items="origemOptions" v-model="origemSelecionada" item-text="text"
                            item-value="value" :label="$t('qrcodeSendHistoryReport.headers.origin')" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="1">
                        <v-select :items="metodoOptions" v-model="metodoSelecionado" item-text="text"
                            item-value="value" :label="$t('qrcodeSendHistoryReport.headers.method')" clearable />
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable :headers="tableHeaders" :items="enviosFiltered" :loading="loading" :default-multi-sort="defaultSort"
            :loading-text="$t('qrcodeSendHistoryReport.loading')"
            cod-tabela="RELHISTORICOENVIOQRCODE" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('qrcodeSendHistoryReport.title')" :token="token" :items="enviosFiltered"
                    csv-title="historicoenvioqrcode" :pdf-title="$t('qrcodeSendHistoryReport.title')" :pdf-headers="tableHeaders"
                    pdf-filename="historicoenvioqrcode" hide-search>
                </CadastroToolbar>
            </template>
            <template v-slot:item.erro="{ item }">
                <v-icon small class="mr-2" :color="item.erro ? 'red' : 'success'">{{ item.erro ? 'mdi-close' : 'mdi-check' }}</v-icon>
            </template>
            <template v-slot:item.status_extenso="{ item }">
                <span :class="{ 'error--text': item.erro, 'success--text': !item.erro }">{{ item.status_extenso }}</span>
            </template>
            <template v-slot:item.mensagem="{ item }">
                <span :class="{ 'error--text': item.erro }">{{ item.mensagem }}</span>
            </template>
        </MerusDataTable>
    </v-container>

</template>
<script>

import apiController from '@/utils/apiController';
import MerusDataTable from "../components/Tables/MerusDataTable.vue"
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import DateUtils from '@/utils/dateutils';
import LazySelect from './Selects/LazySelect.vue';

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
        LazySelect,
    },
    data: () => ({
        headers: [],
        user: null,
        token: null,
        formValidado: false,
        unidadeSelecionada: null,
        grupoSelecionado: null,
        turnoSelecionado: null,
        statusSelecionado: null,
        origemSelecionada: null,
        metodoSelecionado: null,
        envios: [],
        loading: false,
        dti: null,
        dtf: null,
        config: null,
        timeProps: {
            useSeconds: true,
        },
    }),
    computed: {
        defaultSort() {
            return [
                { value: 'dt_envio', options: { text: this.$t('routs.decreasing'), value: -1 } }];
        },
        defaultHeaders() {
            const col = (key, value) => ({
                text: this.$t(`qrcodeSendHistoryReport.headers.${key}`),
                value,
                sortable: true,
                filtrable: true,
                show: true,
            });
            return [
                col('sendDate', 'dt_envio_extenso'),
                col('registration', 'matricula'),
                col('name', 'nome_completo'),
                col('email', 'email'),
                col('unit', 'cod_unidade'),
                col('group', 'nome_grupo'),
                col('shift', 'cod_turno'),
                col('sentBy', 'nome_usuario_envio'),
                col('status', 'status_extenso'),
                col('message', 'mensagem'),
                col('method', 'metodo_extenso'),
                col('origin', 'origem_extenso'),
                col('attempt', 'tentativa'),
            ];
        },
        tableHeaders() {
            return this.headers.length > 0 ? this.headers : this.defaultHeaders;
        },
        statusOptions() {
            return [
                { text: this.$t('qrcodeSendHistoryReport.statusSuccess'), value: 0 },
                { text: this.$t('qrcodeSendHistoryReport.statusError'), value: 1 },
            ];
        },
        origemOptions() {
            // A rotina automática assina os envios com o usuário do monitor, então o
            // "Enviado por" não distingue mais manual de automático — este filtro sim.
            return [
                { text: 'Manual', value: 0 },
                { text: 'Automático', value: 1 },
            ];
        },
        metodoOptions() {
            const vistos = new Map();
            this.envios.forEach((e) => {
                if (e.metodo_extenso && !vistos.has(e.id_metodo)) {
                    vistos.set(e.id_metodo, e.metodo_extenso);
                }
            });
            return Array.from(vistos, ([value, text]) => ({ text, value }));
        },
        enviosFiltered() {
            let dados = this.envios;

            if (this.unidadeSelecionada) {
                dados = dados.filter((d) => d.id_unidade === this.unidadeSelecionada);
            }

            if (this.grupoSelecionado) {
                dados = dados.filter((d) => d.id_grupo === this.grupoSelecionado);
            }

            if (this.turnoSelecionado) {
                dados = dados.filter((d) => d.id_turno === this.turnoSelecionado);
            }

            if (this.statusSelecionado !== null && this.statusSelecionado !== undefined && this.statusSelecionado !== '') {
                dados = dados.filter((d) => Number(d.erro) === Number(this.statusSelecionado));
            }

            if (this.origemSelecionada !== null && this.origemSelecionada !== undefined && this.origemSelecionada !== '') {
                dados = dados.filter((d) => Number(d.automatico) === Number(this.origemSelecionada));
            }

            if (this.metodoSelecionado !== null && this.metodoSelecionado !== undefined && this.metodoSelecionado !== '') {
                dados = dados.filter((d) => Number(d.id_metodo) === Number(this.metodoSelecionado));
            }

            return dados;
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar"
            };
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
            };
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
            };
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {
        initialize() {
            this.getConfig();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
                }
            });
        },
        populaRelatorio() {
            if (!this.dti || !this.dtf) {
                return;
            }

            this.loading = true;

            apiController.request(apiController.endpoints.getHistoricoenviosqrcode, {
                query: {
                    dti: DateUtils.getDateSQLFormatted(this.dti),
                    dtf: DateUtils.getDateSQLFormatted(this.dtf),
                },
                onSuccess: (response) => {
                    this.envios = response.data;
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                }
            });
        }
    }
}
</script>
<style lang="">

</style>
